import { GENERATED_ROUTES } from './GeneratedRoutes';

import { IDataInsight } from '../types/interfaces';

export const generateDataInsightResolutionRoute = ({
  accountId,
  bills,
  meterId,
}: Pick<IDataInsight, 'accountId' | 'bills' | 'meterId'>): string | null => {
  if (bills?.length) {
    if (bills.length === 1) {
      return `${GENERATED_ROUTES.ADMINISTRATION.BILLS}/${bills[0].id}`;
    }

    return `${
      GENERATED_ROUTES.ADMINISTRATION.BILLS
    }?filters=[{"operator":"in","field":"id","value":[${bills
      .map((bill) => `"${bill.id}"`)
      .join(',')}]}]`;
  }

  if (meterId) {
    return `${GENERATED_ROUTES.ADMINISTRATION.BILLS}?filters=[{"operator":"==","field":"meterId","value":"${meterId}"}]`;
  }

  if (accountId) {
    return `${GENERATED_ROUTES.ADMINISTRATION.BILLS}?filters=[{"operator":"==","field":"accountId","value":"${accountId}"}]`;
  }

  return null;
};
